/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {TaskStatusType} from "./task-status-type.enum";

export class TaskStatusDTO extends JSONable {

  uuid: string | undefined = undefined;
  taskUuid: string | undefined = undefined;
  status: TaskStatusType | undefined = undefined;
  lastModifiedByEmployeeName: string | undefined = undefined;
  achievedAt: string | undefined = undefined;
  comment: string | undefined = undefined;

}
